import "./AnimatedWave.css";

const AnimatedWave = () => {
  return (
    <div className="wave-container">
      <svg
        className="wave"
        viewBox="0 0 2880 320"
        preserveAspectRatio="none"
      >
        <path
          fill="#0D1B2A90"
          d="M 0 160 C 377 -2 680 490 1440 160 L 1440 0 L 0 0 Z M 1440 160 C 2010 -118 2538 611 2880 160 L 2880 0 L 1440 0 Z"
        ></path>
        <path
          fill="#0D1B2A70"
          d="M 0 160 C 588 -149 1171 321 1446 324 L 1440 0 L 0 0 Z M 1446 324 C 1740 347 2369 -22 3067.5 158 L 3067.5 0 L 1440 0 Z"
        ></path>
      </svg>
    </div>
  );
};

export default AnimatedWave;
